import { supabase } from '../supabase.js'
import { buildLegacyCandidates, SHARED_TIMEFRAME_SCOPE, PROFILE_TIMEFRAMES } from './sharedTimeframeProfiles.js'
const TABLE='user_chart_preferences'
function check(result) { if(result.error) throw result.error; return result.data }
export function sharedTimeframeTransport(userId, client=supabase) {
  // Owner filters supplement (never replace) existing auth.uid() RLS.
  let cached={}
  const bounded=query=>query.abortSignal(AbortSignal.timeout(10000))
  const owned=()=>client.from(TABLE).select('scope,preference_key,preferences').eq('user_id',userId)
  return {
    async read() {
      const versions=check(await bounded(client.from(TABLE).select('preference_key,revision:preferences->>revision').eq('user_id',userId).eq('scope',SHARED_TIMEFRAME_SCOPE))) || []
      if (versions.some(row=>PROFILE_TIMEFRAMES.includes(row.preference_key) && typeof row.revision!=='string')) throw new Error('Invalid shared profile')
      const changed=versions.filter(row=>PROFILE_TIMEFRAMES.includes(row.preference_key) && cached[row.preference_key]?.revision!==row.revision).map(row=>row.preference_key)
      const rows=changed.length ? check(await bounded(owned().eq('scope',SHARED_TIMEFRAME_SCOPE).in('preference_key',changed))) || [] : []
      const profiles=Object.fromEntries(versions.filter(row=>cached[row.preference_key] && !changed.includes(row.preference_key)).map(row=>[row.preference_key,cached[row.preference_key]]))
      for(const row of rows) {
        if(!PROFILE_TIMEFRAMES.includes(row.preference_key))continue
        const p=row.preferences
        if(p?.version!==1 || typeof p.revision!=='string' || !Array.isArray(p.indicators) || !p.settings || !p.controls) throw new Error('Invalid shared profile')
        profiles[row.preference_key]=p
      }
      cached=profiles
      return profiles
    },
    async legacy() {
      const [templates,prefs]=await Promise.all([
        bounded(client.from('indicator_templates').select('name,preset_snapshots').eq('user_id',userId).eq('is_active',true).like('name','workspace-chart-indicators-v1%')),
        bounded(owned().neq('scope',SHARED_TIMEFRAME_SCOPE)),
      ])
      return buildLegacyCandidates(check(templates)||[],check(prefs)||[])
    },
    async write(tf,preferences,revision) {
      if(!PROFILE_TIMEFRAMES.includes(tf))throw new Error('Invalid timeframe')
      const row={user_id:userId,scope:SHARED_TIMEFRAME_SCOPE,preference_key:tf,preferences,updated_at:new Date().toISOString()}
      if(revision===null) {
        const result=await bounded(client.from(TABLE).insert(row).select('preference_key'))
        if(result.error?.code==='23505')return false
        return (check(result)||[]).length===1
      }
      const result=await bounded(client.from(TABLE).update({preferences,updated_at:row.updated_at})
        .eq('user_id',userId).eq('scope',SHARED_TIMEFRAME_SCOPE).eq('preference_key',tf)
        .eq('preferences->>revision',revision).select('preference_key'))
      return (check(result)||[]).length===1
    },
  }
}
